import Box from '@mui/material/Box';
import Button from '@mui/material/Button';
import { useTheme } from '@mui/material/styles';
import Typography from '@mui/material/Typography';
import { useMemo } from 'react';
import { UrlBuilder } from '@/app/ibaraki-region/builders/UrlBuilder';
import { IBARAKI_REGION_ROUTE } from '@/app/ibaraki-region/constants/region';
import { convertToUrlParams } from '@/functions/convertSearchParams';

type Props = {
  regionSetting: IbarakiRegionSetting;
  searchParams: SearchParams;
};

export const CityButtons: React.FC<Props> = ({
  regionSetting,
  searchParams
}) => {
  const theme = useTheme();
  const cities = useMemo(
    () =>
      Object.entries(regionSetting.cities).sort(
        (a, b) => a[1].cityId - b[1].cityId
      ),
    [regionSetting.cities]
  );
  const queryString = convertToUrlParams({
    ...searchParams,
    area: undefined
  }).toString();

  return (
    <Box
      sx={{
        display: 'flex',
        columnGap: 1,
        rowGap: 0.5,
        flexWrap: 'wrap'
      }}
    >
      <Typography variant="body2" sx={{ mt: 0.75 }}>
        市町村:{' '}
      </Typography>
      {cities.map(([domain, city]) => {
        return (
          <Button
            key={`city-${domain}`}
            LinkComponent="a"
            variant={regionSetting.domain === domain ? 'contained' : 'outlined'}
            size="small"
            sx={{
              borderRadius: 5,
              fontSize: theme.typography.body2.fontSize
            }}
            href={
              regionSetting.domain === domain
                ? new UrlBuilder(IBARAKI_REGION_ROUTE)
                    .setCityDomain(null)
                    .setQueryString(queryString)
                    .build()
                : new UrlBuilder(IBARAKI_REGION_ROUTE)
                    .setCityDomain(domain)
                    .setQueryString(queryString)
                    .build()
            }
          >
            {city.cityName}
          </Button>
        );
      })}
    </Box>
  );
};
